import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

const useViewMode = () => {
  const mediaQuery = useMediaQuery({ query: '(max-width: 768px)' });
  // 쿼리 파라미터를 확인하여 뷰 모드 설정
  const queryParams = new URLSearchParams(window.location.search);
  const viewMode = queryParams.get('view');
  const isGetTypeSize = (viewMode) => {
    if (viewMode === 'mobile') {
      return true;
    } else if (viewMode === 'web') {
      return false;
    } else {
      return mediaQuery;
    }
  };
  const [isMobile, setIsMobile] = useState(isGetTypeSize(viewMode));

  const metaViewPort = (isMobile) => {
    // 모바일 환경에서 PC버전 및 모바일버전 연동을 위한 viewport 설정
    const metaViewport = document.querySelector('meta[name=viewport]');

    const content = isMobile
      ? 'user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width'
      : 'width=1190';

    if (metaViewport) {
      metaViewport.setAttribute('content', content);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = content;
      document.head.appendChild(meta);
    }
  };

  useEffect(() => {
    const isGetSize = isGetTypeSize(viewMode);
    setIsMobile(isGetSize);
    metaViewPort(isGetSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // viewMode, window.location.pathname
  }, []);

  // 모바일 환경의 모바일 버전에서 PC버전으로 연동
  const openDesktopView = () => {
    window.location.href = `${window.location.origin}${window.location.pathname}?view=web`;
  };

  // 모바일 환경의 PC버전에서 모바일버전으로 연동
  const openMobileView = () => {
    window.location.href = `${window.location.origin}${window.location.pathname}?view=mobile`;
  };

  return { isMobile, mediaQuery, openDesktopView, openMobileView };
};

export default useViewMode;
